import { render } from "./AppLeftSideBar.vue?vue&type=template&id=64d90e93"
import script from "./AppLeftSideBar.vue?vue&type=script&lang=js"
export * from "./AppLeftSideBar.vue?vue&type=script&lang=js"

import "./AppLeftSideBar.vue?vue&type=style&index=0&id=64d90e93&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__